import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { Amplify } from 'aws-amplify';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import config from './config';
import Root from './containers/Root';
import './cosmetics/index.css';
import * as serviceWorker from './helpers/serviceWorker';
import store from './redux/stores/MainStore';
const debug = process.env.REACT_APP_DEBUG && false;
const isLocalhost = window.location.hostname === 'localhost';
/**
 * To start locally with `NODE_ENV = 'production'`, use `yarn serveDebug`
 *
 * Be aware hot reloads will not happen, i.e., restart instead.
 * Use this approach to test the production build locally.
 */
const isProduction = !isLocalhost && process.env.NODE_ENV === 'production';
const {
  REACT_APP_DEPLOYMENT_STAGE: stage
} = process.env;
debug && console.log('Environment:', process.env);
debug && !isProduction && console.log('Config:', config);
Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: config.aws.cognito.REGION,
    userPoolId: config.aws.cognito.USER_POOL_ID,
    identityPoolId: config.aws.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.aws.cognito.APP_CLIENT_ID
  },
  API: {
    endpoints: config.aws.apiConfigs
  },
  Storage: {
    AWSS3: {
      bucket: config.aws.s3.userBlobs.Name,
      region: config.aws.default_region
    }
  }
});
Amplify.Logger.LOG_LEVEL = config.aws.amplify.logLevel;
//STRCT MODE WILL DOUBLE RENDER WHEN IN DEVELOPMENT : https://medium.com/@andreasheissenberger/react-components-render-twice-any-way-to-fix-this-91cf23961625
// SUppressed as confusing logging and debug
// ReactDOM.render(
//   <React.StrictMode>
//       <Root store={store} />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
const nonce = config.app.namespace_uuid; // this can be provided by S3 as AddCSPHeader  "s3:ResponseHeader.Content-Security-Policy": "default-src 'self'; style-src 'self' 'nonce-staticNonce123';"
const cache = createCache({
  key: 'css',
  nonce
});
const {
  internalAccountDomain,
  domain
} = config;
function AppWithCallbackAfterRender() {
  useEffect(() => {
    debug && console.log('index.tsx rendered');
  });
  const sources = isProduction ? `https://*.${internalAccountDomain} ${domain ? `https://*.${domain}` : ''}` : 'http://localhost:*';
  //s3.ap-southeast-2.amazonaws.com
  return (
    // @ts-ignore
    _jsx(CacheProvider, {
      value: cache,
      children: _jsxs(HelmetProvider, {
        children: [_jsxs(Helmet, {
          children: [_jsx("meta", {
            id: 'content-security-policy',
            httpEquiv: 'Content-Security-Policy',
            content: `
                      default-src 'self' https://accounts.google.com/gsi/;
                      font-src 'self' https://fonts.gstatic.com;
                      script-src ${sources} https://accounts.google.com/gsi/client https://apis.google.com https://*.gstatic.com https://maps.googleapis.com ${!isProduction ? `'unsafe-eval';` : ';'}
                      img-src self ${sources} data: https://*.gstatic.com https://*.google.com https://*.googleusercontent.com https://*.amazonaws.com https://maps.googleapis.com https://openweathermap.org;
                      frame-src https://*.googleapis.com https://accounts.google.com https://*.google.com;
                      media-src ;
                      style-src 'unsafe-inline' 'self'  https://*.gstatic.com https://*.googleapis.com https://accounts.google.com/gsi/style;
                      connect-src ${sources} https://*.googleapis.com https://www.google.com/* https://apis.google.com https://*.gstatic.com https://ipapi.co wss://*.amazonaws.com https://*.amazonaws.com https://*.iotv.link;
                `
          }), _jsx("script", {
            id: 'google-identity-service',
            nonce,
            src: config.google.clientLibrary.gsi.uri,
            async: true,
            defer: true
          }), _jsx("script", {
            id: 'google-api-client',
            nonce,
            src: config.google.clientLibrary.gapi.uri,
            async: true,
            defer: true
          })]
        }), _jsx(Root, {
          store: store
        })]
      })
    })
  );
}
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(_jsx(AppWithCallbackAfterRender, {}));
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();